/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamTaskEvaluationInputSubEvaluations } from './oralExamTaskEvaluationInputSubEvaluations';
import type { OralExamTaskEvaluationInputOverallFeedback } from './oralExamTaskEvaluationInputOverallFeedback';
import type { OralExamTaskEvaluationInputPromptVersion } from './oralExamTaskEvaluationInputPromptVersion';

/**
 * Oral exam evaluation with per-question dimension grades and feedback.
 */
export interface OralExamTaskEvaluationInput {
  kind?: 'oral_exam';
  subEvaluations: OralExamTaskEvaluationInputSubEvaluations;
  overallFeedback?: OralExamTaskEvaluationInputOverallFeedback;
  promptVersion?: OralExamTaskEvaluationInputPromptVersion;
}
